/**
 * O que faz: cria um preloader idempotente para módulos carregados sob demanda.
 * Onde usa: pre-carregamento da rota Pipeline em hover, foco e clique.
 * Conexões: importação dinâmica do Vite e React.lazy.
 * Tabelas: nenhuma.
 * Data: 28/08/2026
 */

type ImportadorModulo = () => Promise<unknown>;

export function criarPrecarregador(importarModulo: ImportadorModulo) {
  let carregamento: Promise<void> | null = null;

  return () => {
    // Uma única Promise evita downloads repetidos quando hover e foco acontecem em sequência.
    carregamento ??= importarModulo().then(() => undefined);
    return carregamento;
  };
}
